var map = {
	"./CUIABA/rodapeLogo.png": "w/ji",
	"./DOE-AL/rodapeLogo.png": "8nuk",
	"./PMVG/rodapeLogo.png": "XDpy",
	"./TCE-AL/rodapeLogo.png": "g8fZ"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "+jSN";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imagens ^\.\/.*\/rodapeLogo\.png$
// module id = +jSN
// module chunks = 1